import { rupiah, num } from '../../lib/format';
import { PALETTE } from './ShareDonut';

const colorFor = (k, i) => (k.jenis === 'potongan' ? '#F59E0B' : k.jenis === 'lain' ? '#2563EB' : PALETTE[(i + 3) % PALETTE.length]);

const CostCard = ({ c }) => {
  const laba = Math.max(c.laba_persen, 0);
  return (
    <div className="border border-border/60 rounded-xl p-4" data-testid={`cost-card-${c.product_id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="font-display font-semibold">{c.product_nama}</div>
        <div className="text-xs text-muted-foreground text-right">Harga jual<br /><span className="text-sm font-semibold text-foreground tabular-nums">{rupiah(c.harga_jual)}</span></div>
      </div>
      <div className="flex h-3 rounded-full overflow-hidden mt-3 bg-secondary">
        {c.komponen.map((k, i) => <div key={k.nama} title={`${k.nama} ${num(k.persen, 1)}%`} style={{ width: `${k.persen}%`, background: colorFor(k, i) }} />)}
        <div title={`Laba ${num(laba, 1)}%`} style={{ width: `${laba}%` }} className="bg-emerald-500" />
      </div>
      <ul className="mt-3 space-y-1.5 text-sm">
        {c.komponen.map((k, i) => (
          <li key={k.nama} className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: colorFor(k, i) }} />
            <span className="flex-1 truncate">{k.nama}</span>
            {i === 0 && <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300" data-testid={`cost-biggest-${c.product_id}`}>terbesar</span>}
            <span className="tabular-nums text-xs text-muted-foreground">{rupiah(k.nilai)}</span>
            <span className="tabular-nums font-semibold w-14 text-right">{num(k.persen, 1)}%</span>
          </li>
        ))}
        <li className="flex items-center gap-2 pt-1.5 border-t border-border/60">
          <span className="w-2.5 h-2.5 rounded-sm shrink-0 bg-emerald-500" />
          <span className="flex-1">Laba bersih</span>
          <span className="tabular-nums text-xs text-muted-foreground">{rupiah(c.laba_per_unit)}</span>
          <span className={`tabular-nums font-semibold w-14 text-right ${c.laba_persen < 0 ? 'text-rose-600' : 'text-emerald-600 dark:text-emerald-400'}`}>{num(c.laba_persen, 1)}%</span>
        </li>
      </ul>
    </div>
  );
};

export const CostBreakdown = ({ items }) => (
  <div className="bg-card border border-border/60 rounded-xl p-5 lg:p-6" data-testid="cost-breakdown">
    <h3 className="font-display text-lg font-semibold">Persentase Biaya per Produk</h3>
    <p className="text-xs text-muted-foreground mb-4">Porsi tiap biaya dari harga jual per unit. Label "terbesar" menunjukkan biaya yang paling makan untung.</p>
    {items.length === 0 ? (
      <div className="py-10 text-center text-sm text-muted-foreground">Belum ada produk.</div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((c) => <CostCard key={c.product_id} c={c} />)}
      </div>
    )}
  </div>
);
